enum OperatorEnum {
	Turkcell = 0,
	TurkTelekom = 1,
	Vodafone = 2
}

export default OperatorEnum;
